import React from 'react'
import BottomSheetModalComponent, { IBottomSheetProps } from '../bottomSheetModal/BottomSheetModal.component'
import DropdownListSelectComponent, {
  IDropdownListSelectProps,
} from '../dropdownListSelect/DropdownListSelect.component'
import ResizableDynamicPopoverComponent, {
  IResizableDynamicPopoverProps,
} from '../resizableDynamicPopover/ResizableDynamicPopover.component'
import useDeviceMetrics from '../../utilities/useDeviceMetrics'

type MultiActionPanelProps =
  | ({ type: 'dropdown' } & IDropdownListSelectProps)
  | ({ type: 'bottomSheetModal' } & IBottomSheetProps)
  | ({ type: 'popover' } & IResizableDynamicPopoverProps)
  | ({ type: 'tabletSupportModal' } & (IResizableDynamicPopoverProps | IBottomSheetProps))

const MultiActionPanelComponent: React.FC<MultiActionPanelProps> = (props) => {
  const { type, ...rest } = props
  const { isTablet } = useDeviceMetrics()

  switch (type) {
    case 'dropdown':
      return <DropdownListSelectComponent {...(rest as IDropdownListSelectProps)} />
    case 'bottomSheetModal':
      return <BottomSheetModalComponent {...(rest as IBottomSheetProps)} />
    case 'popover':
      return <ResizableDynamicPopoverComponent {...(rest as IResizableDynamicPopoverProps)} />
    case 'tabletSupportModal':
      return isTablet ? (
        <ResizableDynamicPopoverComponent {...(rest as IResizableDynamicPopoverProps)} />
      ) : (
        <BottomSheetModalComponent {...(rest as IBottomSheetProps)} />
      )
    default:
      return null
  }
}

export default MultiActionPanelComponent
